const APP_NET_STATES_UPDATED = (state, app_net_states) => {
  state.app_net_states = app_net_states
}

const APP_NET_STATE_UPDATED = (state, app_net_state) => {
  state.app_net_state = app_net_state
}

const APP_NET_LIST_VIEW_UPDATED = (state, app_net_list_view) => {
  state.app_net_list_view = app_net_list_view
}

const APP_NET_REVISIONS_UPDATED = (state, app_net_revisions) => {
  state.app_net_revisions = app_net_revisions
}

const APP_NET_REVISIONS_VIEW_UPDATED = (state, app_net_revisions_view) => {
  state.app_net_revisions_view = app_net_revisions_view
}

const USER_ERROR = (state, user_error) => {
  state.user_error = user_error
}

const SET_APPLICATION_NETWORK_STATE = (state, application_network_state) => {
  state.application_network_state = application_network_state
}

const UPDATE_APPLICATION_NETWORK_STATE = (state, payload) => {
  state.application_network_state = {
    ...state.application_network_state,
    ...payload,
  }
}

export default {
  APP_NET_STATES_UPDATED,
  APP_NET_STATE_UPDATED,
  APP_NET_LIST_VIEW_UPDATED,
  APP_NET_REVISIONS_UPDATED,
  APP_NET_REVISIONS_VIEW_UPDATED,
  USER_ERROR,
  SET_APPLICATION_NETWORK_STATE,
  UPDATE_APPLICATION_NETWORK_STATE,
}



// WEBPACK FOOTER //
// ./src/modules/applicationNetworkStates/store/mutations.js